import { mobilePaymentValidator } from "./mobile/mobile-payment-validation";
import { webPaymentPlanValidator } from "./web/web-payment-plan-validation";
import { webPaymentDeliveryValidator } from "./web/web-payment-delivery-validation";
import { webPaymentSetupAccountValidator } from "./web/web-payment-account-setup-validation";
import { therapistClientPaymentValidation } from "./therapist-client/therapist-client-payment-validation";
import { partnerPaymentValidation } from "./partner/partner-payment-validation";

// Date regex for DD/MM/YYYY
const DATE_REGEX =
  /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;

// URL regex for http, https, www and etc
const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

// Email regex
const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Hex regex
const HEX_REGEX = /^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;

// Hex regex
const NUMBER_REGEX = /^\d+$/;

const IMAGE_URL = /(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]*/gim;

export {
  DATE_REGEX,
  URL_REGEX,
  EMAIL_REGEX,
  HEX_REGEX,
  NUMBER_REGEX,
  IMAGE_URL,
  mobilePaymentValidator,
  webPaymentPlanValidator,
  webPaymentDeliveryValidator,
  therapistClientPaymentValidation,
  webPaymentSetupAccountValidator,
  partnerPaymentValidation,
};
